$(document).ready(function() {

    var limit = $('#paletteBox').data('limit');

    // Copy colors from Local Storage
    if (sessionStorage.getItem("pbColors") != null) {
        if ($('body').hasClass('product-palette-builder')) {
            var savedColors = sessionStorage.getItem("pbColors").split(',');
            jQuery.each(savedColors, function(i, val) {
                if ($('#paletteBox').attr('data-count') == limit) {
                    
                } else {
                    var boxItem = $('#paletteBox').find('.item:empty').first().append($('#' + val).html());
                    var Id = $('#' + val).attr('id');
                    var name = $('#' + val).data('item-title');
                    var handle = $('#' + val).data('handle');
                    $(boxItem).attr('data-item-id', Id);
                    $(boxItem).attr('data-name', name);
                    $(boxItem).attr('data-handle', handle);
                    $(boxItem).addClass('active');
                    $('#' + val).addClass("selected");
                    $(boxItem).append('<a href="#" class="remove"><img aria-hidden="true" src="https://cdn.shopify.com/s/files/1/0631/2017/9426/files/remove.png"/></a>');
                    $(boxItem).removeClass('empty');
                    $('#paletteBox').attr('data-count', parseInt($('#paletteBox').attr('data-count')) + 1);
                    $('#selectCount').html($('#paletteBox').attr('data-count'));
                }
            });
            window.sessionStorage.removeItem('pbColors');
        }
    }

    $('#1').click(function(){
        window.location.href = '/pages/build-your-own-palette#step1';
    });

    $('#2').click(function(){
        if ($('body').hasClass('product-palette-builder')) {
            window.location.href = '/pages/build-your-own-palette#customPalette';
        } else {
            window.location.href = '/pages/build-your-own-palette#premadePalette';
        }
        
    });

    var count = $('#selectCount').html();
    $('#paletteBox').attr('data-count', parseInt(count));

    $('.productList a').click(function(e) {
        if ($(this).hasClass('selected')) {
            alert("Can't add the same color twice! Please choose a different color.");
        } else {
            if ($('#paletteBox').attr('data-count') == limit) {
                alert('You cant add any more colors.');
            } else {
                e.preventDefault();
                var boxItem = $('#paletteBox').find('.item:empty').first().append($(this).html());
                var Id = $(this).attr('id');
                var name = $(this).data('item-title');
                var handle = $(this).data('handle');
                $(boxItem).attr('data-item-id', Id);
                $(boxItem).attr('data-name', name);
                $(boxItem).attr('data-handle', handle);
                $(boxItem).addClass('active');
                $(this).addClass("selected");
                $(boxItem).append('<a href="#" class="remove"><img aria-hidden="true" src="https://cdn.shopify.com/s/files/1/0631/2017/9426/files/remove.png"/></a>');
                $(boxItem).removeClass('empty');
                $('#paletteBox').attr('data-count', parseInt($('#paletteBox').attr('data-count')) + 1);
                $('#selectCount').html($('#paletteBox').attr('data-count'));
            }
        }
    });

    $(document).on ("click", ".remove", function (e) {
        e.preventDefault();
        var itemId = $(this).parent().attr("data-item-id");
        $("#" + itemId).removeClass('selected');
        $(this).parent().removeClass('active');
        $(this).parent().removeAttr("data-item-id");
        $(this).parent().removeAttr("data-name");
        $(this).parent().removeAttr("data-handle");
        $(this).parent().empty();
        $('#paletteBox').attr('data-count', parseInt($('#paletteBox').attr('data-count')) - 1);
        $('#selectCount').html($('#paletteBox').attr('data-count'));
    });


    $(".selectFilter").change(function () {
        var type = $('#type').val();
        $(".productList").find('a').hide();
        $(".productList").find('div').hide();
        $(".productList").find('a[data-tags*="' + type + '"]').show();
        $(".productList").find('div[data-tags*="' + type + '"]').show();
    });

    $('#changePalette').click(function(e){
        e.preventDefault();
        $("#pmoverlay").fadeIn(100);
        var pbColors = [];
        var total = $('#paletteBox .active').length;
        if (total != 0) {
            $('#paletteBox').children('.active').each(function(index) {
                pbColors.push($(this).data('item-id'));
            });
            sessionStorage.setItem('pbColors', pbColors);
        }
        $("#pmoverlay").hide();
        document.location.href ='/pages/build-your-own-palette#customPalette';
    });

    $('#clearPalette').click(function(e){
        e.preventDefault();
        $("#pmoverlay").fadeIn(100);
        $('#paletteBox').attr('data-count', 0);
        $('#selectCount').html('0');
        $('#paletteBox').children('.item').each(function() {
            $(this).removeAttr("data-item-id");
            $(this).removeAttr("data-name");
            $(this).removeAttr("data-handle");
            $(this).empty();
            $(this).removeClass('active');
        });
        $('.productList').children('.selected').each(function() {
            $(this).removeClass('selected');
        });
        $("#pmoverlay").hide();
    });


});


$("#pbAtc").click(function(e){
    e.preventDefault();
    $("#pmoverlay").fadeIn(100);

    var boxName = $('#paletteBox').data('name');
    var boxId = $('#paletteBox').data('box-id');
    var boxCount = $('#paletteBox').data('count');
    var total = $('#paletteBox .active').length;
    var cartColors = '';
    $('#paletteBox').children('.active').each(function(index) {
        if (index === total - 1) {
            cartColors += $(this).data('name');
        } else {
            cartColors += $(this).data('name');
            cartColors += ', ';
        }
    });

    let colorArray = [];
    
    $('#paletteBox').children('.active').each(function() {
        var obj = {id: $(this).data('item-id'), quantity: '1', properties: {Palette: boxName}};
        colorArray.push(obj);
    });

    var obj = {id: boxId, quantity: '1', properties: {Size: boxCount, Colors: cartColors}};
        colorArray.push(obj);
  
    var data = {
      items: colorArray
    }

    var limit = $('#paletteBox').data('limit');

      fetch('/cart/add.js', {
          body: JSON.stringify(data),
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With':'xmlhttprequest'
          },
          method: 'POST'
        }).then((response) => {
          return response.json();
        }).then((json) => {
                document.location.href = "/cart";
        }).catch((err) => {
          /* uh oh, we have error. */
          console.error(err)
        });
});